import React, { useContext, useState, useEffect } from "react";
import { ThemeContext } from "../../../context/ThemeContext";
import SaudiFacultyPercentageChart from "../../components/charts/my_charts/SaudiFacultyPercentageChart";
import PhdFacultyPercentageChart from "../../components/charts/my_charts/PhdFacultyPercentageChart";
import FacultyStudentRatioChartComponenet from "../../components/charts/my_charts/FacultyStudentRatioChartComponenet";

const Faculty = () => {
  const { changeBackground, background } = useContext(ThemeContext);
  const [loading, setLoading] = useState(true);

  const [years, setYears] = useState([]);
  const [selectedYear, setSelectedYear] = useState(null);

  const [totalFacultyCount, setTotalFacultyCount] = useState(null);

  // sadui
  const [malePercentages, setMalePercentages] = useState([]);
  const [femalePercentages, setFemalePercentages] = useState([]);
  const [universities, setUniversities] = useState([]);

  // not sadui
  const [malePercentagesNotSadui, setMalePercentagessNotSadui] = useState([]);
  const [femalePercentagessNotSadui, setFemalePercentagessNotSadui] = useState(
    []
  );
  const [universitiessNotSadui, setUniversitiessNotSadui] = useState([]);

  const [phdPercentages, setPhdPercentages] = useState([]);
  const [nonPhdPercentages, setNonPhdPercentages] = useState([]);
  const [universityNames, setUniversityNames] = useState([]);


  const [ratios, setRatios] = useState([]);
const [universityNamesRatios, setUniversityNamesRatios] = useState([]);

  const fetchYears = async () => {
    try {
      const response = await fetch(
        "https://plo.areez.co//api/university/academic_years"
      );

      if (!response.ok) throw new Error("فشل في تحميل بيانات");
      const data = await response.json();
      setYears(data);
      setSelectedYear(data[0].id);
      setTimeout(() => {
        handleSearch(data[0].id);
      }, 0);
    } catch (error) {
      console.error("خطأ:", error);
      setYears([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchTotalFacultyCount = async (academicYearId) => {
    try {
      const response = await fetch(
        `https://plo.areez.co/api/faculty/total?academic_year_id=${academicYearId}`
      );
      if (!response.ok) throw new Error("فشل في تحميل البيانات");

      const data = await response.json();
      setTotalFacultyCount(data);
    } catch (error) {
      console.error("خطأ في تحميل البيانات:", error);
      setTotalFacultyCount(null);
    } finally {
      setLoading(false);
    }
  };

  const fetchSaudiFacultyPercentages = async (academicYearId) => {
    try {
      const response = await fetch(
        `https://plo.areez.co/api/universities/faculty/saudi?academic_year_id=${academicYearId}`
      );
      if (!response.ok) throw new Error("فشل تحميل بيانات النسب");

      const data = await response.json();

      const males = data.map((item) => item.saudi_male_percentage);
      const females = data.map((item) => item.saudi_female_percentage);
      const names = data.map((item) => item.university);

      setMalePercentages(males);
      setFemalePercentages(females);
      setUniversities(names);
    } catch (error) {
      console.error("خطأ أثناء تحميل نسب هيئة التدريس السعوديين:", error);
      setMalePercentages([]);
      setFemalePercentages([]);
      setUniversities([]);
    }
  };

  const fetchNotSaudiFacultyPercentages = async (academicYearId) => {
    try {
      const response = await fetch(
        `https://plo.areez.co/api/universities/faculty/non_saudi?academic_year_id=${academicYearId}`
      );
      if (!response.ok) throw new Error("فشل تحميل بيانات النسب");

      const data = await response.json();

      const males = data.map((item) => item.non_saudi_male_percentage);
      const females = data.map((item) => item.non_saudi_female_percentage);
      const names = data.map((item) => item.university);

      setMalePercentagessNotSadui(males);
      setFemalePercentagessNotSadui(females);
      setUniversitiessNotSadui(names);
    } catch (error) {
      console.error("خطأ أثناء تحميل نسب هيئة التدريس السعوديين:", error);
      setMalePercentagessNotSadui([]);
      setFemalePercentagessNotSadui([]);
      setUniversitiessNotSadui([]);
    }
  };

  const fetchPhdFacultyPercentages = async (academicYearId) => {
    try {
      const response = await fetch(
        `https://plo.areez.co/api/universities/faculty/phd?academic_year_id=${academicYearId}`
      );
      if (!response.ok) throw new Error("فشل تحميل بيانات النسب");
  
      const data = await response.json();
  
      const phd = data.map((item) => item.phd_percentage);
      const nonPhd = data.map((item) => item.non_phd_percentage);
      const names = data.map((item) => item.university_name);
  
      setPhdPercentages(phd);
      setNonPhdPercentages(nonPhd);
      setUniversityNames(names);
    } catch (error) {
      console.error("خطأ أثناء تحميل بيانات حملة الدكتوراه:", error);
      setPhdPercentages([]);
      setNonPhdPercentages([]);
      setUniversityNames([]);
    }
  };

  const fetchFacultyStudentRatio = async (academicYearId) => {
    try {
      const response = await fetch(
        `https://plo.areez.co/api/universities/faculty_student_ratio?academic_year_id=${academicYearId}`
      );
      if (!response.ok) throw new Error("فشل تحميل البيانات");
  
      const result = await response.json();
      const data = result.data;
  
      setRatios(data.map((item) => item.faculty_to_student_ratio));
      setUniversityNamesRatios(data.map((item) => item.university_name));
    } catch (error) {
      console.error("خطأ أثناء تحميل نسبة هيئة التدريس إلى الطلاب:", error);
      setRatios([]);
      setUniversityNamesRatios([]);
    }
  };

  const handleSearch = (yearId) => {
    // if (!selectedYear) {
    //   alert("يرجى اختيار السنة الدراسية أولاً.");
    //   return;
    // }
    const yearToUse = yearId || selectedYear;
    if (!yearToUse) {
      alert("يرجى اختيار السنة الدراسية أولاً.");
      return;
    }
    setLoading(true);

    fetchTotalFacultyCount(yearToUse);
    fetchSaudiFacultyPercentages(yearToUse);
    fetchNotSaudiFacultyPercentages(yearToUse);
    fetchPhdFacultyPercentages(yearToUse);
    fetchFacultyStudentRatio(yearToUse);
  };

  useEffect(() => {
    fetchYears();

    changeBackground({ value: "light", label: "Light" });
  }, []);

  return (
    <div className="row">
      <div className="col-12 mb-4">
        <div className="input-group">
          <select
            className="form-control"
            value={selectedYear || ""}
            onChange={(e) => setSelectedYear(e.target.value)}
          >
            <option value="">اختر السنة الدراسية</option>
            {years.map((year) => (
              <option key={year.id} value={year.id}>
                {year.name}
              </option>
            ))}
          </select>
          <div className="input-group-append">
            <button
              className="btn btn-primary"
              // onClick={handleSearch}
              onClick={() => handleSearch(selectedYear)}
              disabled={loading}
            >
              <i className="fa fa-search mr-1"></i>{" "}
              {loading ? "جارٍ البحث..." : ""}
            </button>
          </div>
        </div>
      </div>

      {totalFacultyCount != null && (
        <div className="col-12 mb-4">
          <div className="widget-stat card bg-success">
            <div className="card-body">
              <div className="media pb-2">
                <span className="mr-3">
                  <i className="fa fa-id-badge fa-1x text-white"></i>
                </span>
                <div className="media-body text-white">
                  <p className="mb-1">عدد هيئة التدريس في كل الجامعات</p>
                  <h3 className="text-white">
                    {totalFacultyCount.total_faculty}
                  </h3>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {malePercentages.length > 0 && femalePercentages.length > 0 && (
        <div className="col-12 col-lg-6  mb-4">
          <SaudiFacultyPercentageChart
            maleData={malePercentages}
            femaleData={femalePercentages}
            categories={universities}
            title="نسبة أعضاء هيئة التدريس السعوديين حسب الجنس"
            colors={["#2e86de", "#e84393"]}
          />
        </div>
      )}

      {malePercentagesNotSadui.length > 0 &&
        femalePercentagessNotSadui.length > 0 && (
          <div className="col-12 col-lg-6  mb-4">
            <SaudiFacultyPercentageChart
              maleData={malePercentagesNotSadui}
              femaleData={femalePercentagessNotSadui}
              categories={universitiessNotSadui}
              title="نسبة أعضاء هيئة التدريس  غير السعوديين حسب الجنس"
              colors={["#555555", "#F5A962"]}
            />
          </div>
        )}

{phdPercentages.length > 0 && nonPhdPercentages.length > 0 && (
  <div className="col-12 col-lg-6 mb-4">
    <PhdFacultyPercentageChart
      phdData={phdPercentages}
      nonPhdData={nonPhdPercentages}
      categories={universityNames}
      title="نسبة أعضاء هيئة التدريس حملة الدكتوراه وغيرهم"
      colors={["#00b894", "#d63031"]}
    />
  </div>
  
)}

{ratios.length > 0 && universityNamesRatios.length > 0 && (
  <div className="col-12 col-lg-6 mb-4">
    <FacultyStudentRatioChartComponenet
      ratios={ratios}
      categories={universityNamesRatios}
      color="#E74C3C"
      title="معدل أعضاء هيئة التدريس إلى الطلاب في الجامعات"
    />
  </div>
)}


    </div>
  );
};
export default Faculty;
